/** 

=========================================================
* Vision UI  React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vision-ui-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Visionware.

*/

/**
 * The base colors for the Vision UI Dashboard  Material.
 * You can add new color using this file.
 * You can customized the colors for the entire Vision UI Dashboard  Material using thie file.
 */

export default {
  // Vision UI Colors
  background: {
    default: "#0a0e1a",
  },

  sidenav: {
    button: "#0a0e1a",
  },

  text: {
    main: "#a0aec0",
    focus: "#ffffff",
  },

  transparent: {
    main: "transparent",
  },

  white: {
    main: "#ffffff",
    focus: "#ffffff",
  },

  brand: {
    main: "#00CED1",
    focus: "#00CED1",
  },

  black: {
    light: "#141414",
    main: "#000000",
    focus: "#000000",
  },

  primary: {
    main: "#00CED1",
    focus: "#20B2AA",
  },

  secondary: {
    main: "#0a0e1a",
    focus: "#0d111f",
  },

  lightblue: {
    main: "#00CED1",
    focus: "#00CED1",
  },

  orange: {
    main: "#f6ad55",
    focus: "#f6ad55",
  },

  grey: {
    100: "#edf2f7",
    200: "#e2e8f0",
    300: "#cbd5e0",
    400: "#a0aec0",
    500: "#718096",
    600: "#4a5568",
    700: "#2d3748",
    800: "#1a202a",
    900: "#171923",
  },

  borderCol: {
    main: "#00CED1",
    red: "#e31a1a",
    navbar: "rgba(0, 206, 209, 0.3)",
  },

  // Other colors
  info: {
    main: "#00CED1",
    focus: "#20B2AA",
    charts: {
      100: "#00CED1",
      200: "#00A8AA",
      300: "#008B8D",
      400: "#006D70",
      500: "#005F62",
      600: "#004F52",
    },
  },

  success: {
    main: "#01b574",
    focus: "#35d28a",
  },

  warning: {
    main: "#ffb547",
    focus: "#ffcd75",
  },

  error: {
    main: "#e31a1a",
    focus: "#ee5d50",
  },

  light: {
    main: "#e9ecef",
    focus: "#ebeff4",
  },

  dark: {
    main: "#0a0e1a",
    focus: "#060914",
    body: "#000000",
  },

  gradients: {
    navbar: {
      deg: "123.64deg",
      main: "rgba(0, 206, 209, 0.05) -22.38%",
      state: "rgba(0, 206, 209, 0.08) 70.38%",
    },

    sidenav: {
      deg: "127.09",
      main: "rgba(0, 206, 209, 0.1) 19.41%",
      state: "rgba(10, 14, 26, 0.95) 76.65%",
    },

    borderLight: {
      angle: "94.43% 69.43% at 50% 50%",
      main: "#ffffff 0%",
      state: "rgba(255, 255, 255, 0) 100%",
    },

    borderDark: {
      angle: "69.43% 69.43% at 50% 50%",
      main: "#ffffff 0%",
      state: "rgba(255, 255, 255, 0) 100%",
    },

    cover: {
      deg: "159.02",
      main: "rgba(0, 206, 209, 0.1) 14.25%",
      state: "rgba(10, 14, 26, 0.9) 56.45%",
      stateSecondary: "rgba(0, 0, 0, 0.95) 86.14%",
    },

    cardDark: {
      deg: "126.97",
      main: "rgba(0, 206, 209, 0.08) 28.26%",
      state: "rgba(10, 14, 26, 0.95) 91.2%",
    },

    cardLight: {
      deg: "127.09",
      main: "rgba(0, 206, 209, 0.08) 19.41%",
      state: "rgba(10, 14, 26, 0.95) 76.65%",
    },

    card: {
      deg: "127.09",
      main: "rgba(0, 206, 209, 0.08) 19.41%",
      state: "rgba(10, 14, 26, 0.95) 76.65%",
    },

    menu: {
      deg: "126.97",
      main: "rgba(0, 206, 209, 0.08) 28.26%",
      state: "rgba(10, 14, 26, 0.95) 91.2%",
    },

    cardContent: {
      deg: "126.97",
      main: "rgba(0, 206, 209, 0.08) 28.26%",
      state: "rgba(10, 14, 26, 0.95) 91.2%",
    },

    box: {
      deg: "126.97",
      main: "rgba(0, 206, 209, 0.08) 28.26%",
      state: "rgba(10, 14, 26, 0.95) 91.2%",
    },

    bill: {
      deg: "127.09",
      main: "rgba(0, 206, 209, 0.08) 19.41%",
      state: "rgba(10, 14, 26, 0.95) 76.65%",
    },

    primary: {
      deg: "97.89",
      main: "#00CED1",
      state: "#20B2AA",
    },

    secondary: {
      main: "#00CED1",
      state: "#00FFFF",
    },

    logo: {
      deg: "97.89",
      main: "#ffffff 70.67%",
      state: "rgba(0, 206, 209, 0.2) 108.55%",
    },

    info: {
      main: "#00CED1",
      state: "#00FFFF",
    },

    success: {
      main: "#01B574",
      state: "#c9fbd5",
    },

    warning: {
      main: "#f53939",
      state: "#fbcf33",
    },

    error: {
      main: "#f53c2b",
      state: "#f53c2b",
    },

    light: {
      main: "#ced4da",
      state: "#ebeff4",
    },

    dark: {
      main: "#0a0e1a",
      state: "#00CED1",
    },
  },

  socialMediaColors: {
    facebook: {
      main: "#3b5998",
      dark: "#344e86",
    },

    twitter: {
      main: "#55acee",
      dark: "#3ea1ec",
    },

    instagram: {
      main: "#125688",
      dark: "#0e456d",
    },

    linkedin: {
      main: "#0077b5",
      dark: "#00669c",
    },

    pinterest: {
      main: "#cc2127",
      dark: "#b21d22",
    },

    youtube: {
      main: "#e52d27",
      dark: "#d41f1a",
    },

    vimeo: {
      main: "#1ab7ea",
      dark: "#13a3d2",
    },

    slack: {
      main: "#3aaf85",
      dark: "#329874",
    },

    dribbble: {
      main: "#ea4c89",
      dark: "#e73177",
    },

    github: {
      main: "#24292e",
      dark: "#171a1d",
    },

    reddit: {
      main: "#ff4500",
      dark: "#e03d00",
    },

    tumblr: {
      main: "#35465c",
      dark: "#2a3749",
    },
  },

  alertColors: {
    primary: {
      main: "#00CED1",
      state: "#00FFFF",
      border: "#b9ecf8",
    },

    secondary: {
      main: "#00CED1",
      state: "#00FFFF",
      border: "#b9ecf8",
    },

    info: {
      main: "#00CED1",
      state: "#00FFFF",
      border: "#b9ecf8",
    },

    success: {
      main: "#17ad37",
      state: "#84dc14",
      border: "#daf3b9",
    },

    warning: {
      main: "#f53939",
      state: "#fac60b",
      border: "#fef1c2",
    },

    error: {
      main: "#ea0606",
      state: "#ff3d59",
      border: "#f9b4b4",
    },

    light: {
      main: "#ced4da",
      state: "#d1dae6",
      border: "#f8f9fa",
    },

    dark: {
      main: "#0a0e1a",
      state: "#00CED1",
      border: "#00CED1",
    },
  },

  badgeColors: {
    primary: {
      basic: "#00CED1",
      background: "#00FFFF",
      text: "#00A8AA",
    },

    secondary: {
      basic: "#00CED1",
      background: "#e4f8f9",
      text: "#00CED1",
    },

    info: {
      basic: "#00CED1",
      background: "#abe9f7",
      text: "#00A8AA",
    },

    success: {
      basic: "#01b574",
      background: "#c9fbd5",
      text: "#01b574",
    },

    warning: {
      basic: "#ffb547",
      background: "#fef5d3",
      text: "#fbc400",
    },

    error: {
      basic: "#e31a1a",
      background: "#fc9797",
      text: "#bd0000",
    },

    light: {
      basic: "#ffffff",
      background: "#ffffff",
      text: "#c7d3de",
    },

    dark: {
      basic: "#0a0e1a",
      background: "#0a0e1a",
      text: "#00CED1",
    },
  },

  inputColors: {
    backgroundColor: "#0a0e1a",
    borderColor: { main: "rgba(0, 206, 209, 0.3)", focus: "rgba(0, 206, 209, 0.8)" },
    boxShadow: "#00CED1",
    error: "#fd5c70",
    success: "#66d432",
  },

  sliderColors: {
    thumb: { borderColor: "#d9d9d9" },
  },

  circleSliderColors: {
    background: "#d3d3d3",
  },

  tabs: {
    indicator: { boxShadow: "#ddd" },
  },
};
